import { getValidationResult } from './index';

const SPRINT = {
	TITLE_MIN_LENGTH: 3,
	TITLE_MAX_LENGTH: 100,
	GOAL_MIN_LENGTH: 2,
	GOAL_MAX_LENGTH: 8000
};

const ERROR_MESSAGES = {
	SPRINT: {
		TITLE: `عنوان باید بیشتر از  ${SPRINT.TITLE_MIN_LENGTH}
		 وکمتر از ${SPRINT.TITLE_MAX_LENGTH} کاراکتر باشد`,
		TITLE_REQUIRED: 'عنوان اجباری است',
		GOAL: `نتیجه باید بیشتر از ${SPRINT.GOAL_MIN_LENGTH} و کمتر از ${SPRINT.GOAL_MAX_LENGTH} کاراکتر باشد`,
		END_DATE_REQUIRED: 'تاریخ اتمام اجباری می باشد',
		START_DATE_REQUIRED: 'تاریخ شروع اجباری می باشد'
	}
};

export const validateTitle = ({ Title }) => {
	if (!Title) {
		return getValidationResult(false, ERROR_MESSAGES.SPRINT.TITLE_REQUIRED);
	}

	const isValid = Title.length >= SPRINT.TITLE_MIN_LENGTH && Title.length <= SPRINT.TITLE_MAX_LENGTH;
	return getValidationResult(isValid, ERROR_MESSAGES.SPRINT.TITLE);
};

export const validateStartDate = ({ StartDate }) => {
	if (!StartDate) {
		return getValidationResult(false, ERROR_MESSAGES.SPRINT.START_DATE_REQUIRED);
	}

	return true;
};

export const validateEndDate = ({ EndDate }) => {
	if (!EndDate) {
		return getValidationResult(false, ERROR_MESSAGES.SPRINT.END_DATE_REQUIRED);
	}

	return true;
};

export const validateGoal = ({ Goal }) => {
	if (!Goal) {
		return true;
	}
	const isValid = Goal.length >= SPRINT.GOAL_MIN_LENGTH && Goal.length <= SPRINT.GOAL_MAX_LENGTH;
	return getValidationResult(isValid, ERROR_MESSAGES.SPRINT.GOAL);
};
